<template>
    <kgr-lightbox
        :value="show"
        :headline="$t('Hinweis')"
        scrollable
        @post-input="$emit('close')"
    >
        <div class="kgr-text kgr-text--preserveLineBreaks">
            {{ $t('Sie können nicht mehr als 100 Rechnungen auf einmal herunterladen.') }}
            {{ $t('Sie haben {selectedCount} Rechnungen ausgewählt.', { selectedCount }) }}
        </div>
        <template #footer>
            <button
                class="kgr-button kgr-button--accent"
                @click="$emit('close')"
            >
                {{ $t('Ok') }}
            </button>
        </template>
    </kgr-lightbox>
</template>

<script>
import Lightbox from '../../common/modal/Lightbox.vue';

export default {
    components: {
        'kgr-lightbox': Lightbox,
    },
    props: {
        show: {
            type: Boolean,
            required: true,
        },
        selectedCount: {
            type: Number,
            required: true,
        },
    },
    emits: ['close'],
};
</script>
